import { gql } from "@apollo/client";

export const getCalculations = gql`
query GetCalculations($input: CalculationRequestInput!) {
  getCalculations(input: $input) {
    code
    label
    logoUrl
    priceWithoutDiscounts
    fixedCoverages {
      code
      label
      tooltip
      description
    }
    coverages {
      code
      label
      tooltip
      price
      description
    }
    prices {
      generalTransfer
      generalTransferWithInstallments
      creditCard
      creditCardWithInstallments
    }
    detailsLink
    premiumEligibleAgeMin
    premiumEligibleAgeMax
  }
}
`;